import script from "./ChatbotPanelControls.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotPanelControls.vue?vue&type=script&setup=true&lang=js"

import "./ChatbotPanelControls.vue?vue&type=style&index=0&id=5c65e4d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c65e4d3"]])

export default __exports__